import { render, staticRenderFns } from "./SimpleDropdown.vue?vue&type=template&id=481ac2e2&scoped=true"
import script from "./SimpleDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&lang=js"
import style0 from "./SimpleDropdown.vue?vue&type=style&index=0&id=481ac2e2&prod&scoped=true&lang=scss"
import style1 from "./SimpleDropdown.vue?vue&type=style&index=1&id=481ac2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481ac2e2",
  null
  
)

export default component.exports